<template>
	<b-table
		class="UsersTable"
		hoverable
		paginated
		backend-pagination
		:data="users"
		:loading="isLoading"
		:empty="!isLoading && total === 0"
		:total="total"
		:per-page="perPage"
		backend-sorting
		default-sort-direction="desc"
		:default-sort="[sortParams.field, sortParams.order]"
		@page-change="changePage"
		@sort="changeSortParams"
		:row-class="(row) => !row.isActive && 'is-not-active'"
	>
		<template slot-scope="props">
			<b-table-column field="id" label="ID" sortable>
				{{ props.row.id }}
			</b-table-column>

			<b-table-column field="name" label="Użytkownik">
				<a href="" @click.prevent="$emit('user-click', props.row)" class="user-link">
					<span class="user-name">{{ props.row.username }}</span>
				</a>
			</b-table-column>

			<b-table-column field="orders" label="Liczba zamówień">
				{{ props.row.orders.length }}
			</b-table-column>

			<b-table-column field="isActive" label="Konto aktywne">
				{{ props.row.isActive ? 'tak' : 'nie' }}
			</b-table-column>

			<b-table-column field="mailerIsEnabled" label="Mailer włączony">
				{{ props.row.mailerIsEnabled ? 'tak' : 'nie' }}
			</b-table-column>

			<b-table-column field="mailerIsActive" label="Mailer aktywowany">
				{{
					props.row.mailerIsActive
						? 'tak (' + (props.row.mailerMode === 'gmail' ? 'gmail' : 'zwykły') + ')'
						: 'nie'
				}}
			</b-table-column>

			<b-table-column field="isAdmin" label="Admin">
				{{ props.row.isAdmin ? 'tak' : 'nie' }}
			</b-table-column>

			<b-table-column field="createdDate" label="Dodano">
				<div v-if="props.row.createdDate">
					{{ props.row.createdDate | humanDate }}
					<small>{{ props.row.createdDate | date('DD/MM/YYYY') }}</small>
				</div>
				<span v-else>-</span>
			</b-table-column>
		</template>
		<template slot-scope="props" slot="header">
			{{ props.column.label }}
			<i
				v-show="sortParams.field === props.column.field"
				:class="{ mdi: true, 'is-desc': sortParams.order === 'desc' }"
			>
				arrow_upward
			</i>
		</template>
		<template slot="empty">
			<section class="section">
				<div class="content has-text-grey has-text-centered">
					<p>
						<b-icon icon="emoticon-sad" size="is-large"> </b-icon>
					</p>
					<p>Brak użytkowników.</p>
				</div>
			</section>
		</template>
		<template slot="bottom-left">
			<div class="per-page">
				<span>Wyświetlaj rekordów:</span>
				<b-select @input="changePerPage($event)" :value="perPage">
					<option
						v-for="(value, index) in perPageOptions"
						:key="index"
						:value="value"
						:selected="value === perPage"
					>
						{{ value }}
					</option>
				</b-select>
			</div>
		</template>
	</b-table>
</template>

<script>
import moment from 'moment'

import config from '@/config'
import bus from '@/EventBus'
import UserService from '@/services/UserService'

export default {
	data() {
		return {
			users: [], // current loaded
			checkedRows: [],
			perPage: localStorage.getItem('users-table-per-page') || 10,
			perPageOptions: config.company.perPageOptions,
			pageNr: 1,
			sortParams: {
				field: 'id',
				order: 'desc'
			},
			total: 0,
			isLoading: false
		}
	},
	methods: {
		changePage(pageNr) {
			this.pageNr = pageNr
			this.loadUsers()
		},
		changePerPage(num) {
			this.perPage = num
			localStorage.setItem('users-table-per-page', this.perPage)
			this.loadUsers()
		},
		changeSortParams(field, order) {
			this.sortParams = { field, order }
			this.loadUsers()
		},
		loadUsers() {
			this.isLoading = true
			UserService.getAll(this.sortParams, this.perPage, this.pageNr)
				.then((res) => this.loadUsersSuccess(res.data))
				.catch((err) => this.loadUsersFailure(err))
		},
		loadUsersSuccess(data) {
			this.users = []
			this.total = data['hydra:totalItems']
			if (this.total / this.perPage > 1000) {
				this.total = this.perPage * 1000
			}
			this.isLoading = false
			if (this.total === 0) return false
			data['hydra:member'].forEach((item) => {
				this.users.push(item)
			})
			this.checkedRows = []
			bus.$emit('users-loaded')
		},
		loadUsersFailure(err) {
			this.users = []
			this.isLoading = false
			throw { error: err }
		}
	},
	filters: {
		date(value, format) {
			return moment(value).format(format)
		},
		humanDate(value) {
			return moment(value).fromNow()
		}
	},
	created() {
		moment.locale('pl')

		this.events = ['user-created', 'user-updated', 'user-deleted']
		bus.$on(this.events, () => {
			this.loadUsers()
		})
		bus.$on(['users-loaded'], () => {
			this.checkedRows = []
		})
	},
	mounted() {
		this.loadUsers()
	},
	destroyed() {
		bus.$off(this.events)
	}
}
</script>

<style lang="scss" scoped>
td.nowrap {
	white-space: nowrap;
}
[data-label='Dodano'] {
	small {
		display: block;
		font-size: 11px;
		color: #aaa;
	}
}
.route-link {
	& > * {
		vertical-align: middle;
	}
}
.route-color-preview {
	width: 20px;
	height: 20px;
	display: inline-block;
	margin: 5px 5px 0;
	border: 1px solid #ccc;
	border-radius: 3px;
}
.per-page {
	> span {
		margin-right: 10px;
		vertical-align: middle;
	}
	> div {
		display: inline-block;
		vertical-align: middle;
	}
}
tr.is-not-active {
	td,
	a {
		color: red;
		background-color: #ffecec;
	}
}
</style>
